import { FolderSearch } from "lucide-react";

import {
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";

import { useOwnedPlaylists } from "../api/fetch-owned-playlists";

import { CreatePlaylistModal } from "./create-playlist-modal";
import { PlaylistItem } from "./playlist-item";

type AddToPlaylistProps = {
  recordingId: string;
};

export function AddToPlaylist(props: AddToPlaylistProps) {
  const { organisation } = useOrganisation();
  const {
    data: playlists,
    isSuccess,
    isLoading,
  } = useOwnedPlaylists(organisation.id);
  return (
    <DialogContent className="max-w-xl">
      <DialogHeader>
        <DialogTitle>Add to playlist</DialogTitle>
      </DialogHeader>
      <DialogBody>
        {isLoading && (
          <div className="flex flex-col gap-2">
            <Skeleton className="h-9 w-full rounded-md bg-border" />
            <Skeleton className="h-9 w-full rounded-md bg-border" />
          </div>
        )}
        {isSuccess && playlists.length > 0 && (
          <div className="space-y-2">
            {playlists.map((playlist) => (
              <PlaylistItem
                key={playlist.id}
                playlist={playlist}
                recordingId={props.recordingId}
              />
            ))}
          </div>
        )}
        {isSuccess && playlists.length === 0 && (
          <div className="flex flex-col gap-2 text-center">
            <FolderSearch className="mx-auto size-6 text-muted-foreground" />
            <p className="text-muted-foreground">No playlists found</p>
          </div>
        )}

        <div className="mt-4 flex flex-col">
          <CreatePlaylistModal
            variant="outline"
            isEmpty={isSuccess && playlists.length === 0}
          />
        </div>
      </DialogBody>
    </DialogContent>
  );
}
